@if (image) {
  <div>
    <img
      [src]="image.url"
      class="mx-auto w-32 lg:w-full"
    />
  </div>
}
